// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"7819c9e7","337":"db5fd6b4"}[chunkId] + ".chunk.css";
};